var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 11,
    viewBox: "0 0 71 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70281 8.84053L9.22715 11L8.29189 6.93L11.4056 4.19158L7.3053 3.83842L5.70281 0L4.10032 3.83842L0 4.19158L3.11373 6.93L2.17847 11L5.70281 8.84053ZM20.6014 8.84053L24.1257 11L23.1905 6.93L26.3042 4.19158L22.2039 3.83842L20.6014 0L18.9989 3.83842L14.8986 4.19158L18.0123 6.93L17.0771 11L20.6014 8.84053ZM39.0243 11L35.5 8.84053L31.9757 11L32.9109 6.93L29.7972 4.19158L33.8975 3.83842L35.5 0L37.1025 3.83842L41.2028 4.19158L38.0891 6.93L39.0243 11ZM50.3986 8.84053L53.9229 11L52.9877 6.93L56.1014 4.19158L52.0011 3.83842L50.3986 0L48.7961 3.83842L44.6958 4.19158L47.8095 6.93L46.8743 11L50.3986 8.84053ZM68.8215 11L65.2972 8.84053L61.7729 11L62.7081 6.93L59.5944 4.19158L63.6947 3.83842L65.2972 0L66.8997 3.83842L71 4.19158L67.8863 6.93L68.8215 11Z",
    fill: "#B3BDBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_2214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70281 8.84053L9.22715 11L8.29189 6.93L11.4056 4.19158L7.3053 3.83842L5.70281 0L4.10032 3.83842L0 4.19158L3.11373 6.93L2.17847 11L5.70281 8.84053ZM20.6014 8.84053L24.1257 11L23.1905 6.93L26.3042 4.19158L22.2039 3.83842L20.6014 0L18.9989 3.83842L14.8986 4.19158L18.0123 6.93L17.0771 11L20.6014 8.84053ZM39.0243 11L35.5 8.84053L31.9757 11L32.9109 6.93L29.7972 4.19158L33.8975 3.83842L35.5 0L37.1025 3.83842L41.2028 4.19158L38.0891 6.93L39.0243 11ZM50.3986 8.84053L53.9229 11L52.9877 6.93L56.1014 4.19158L52.0011 3.83842L50.3986 0L48.7961 3.83842L44.6958 4.19158L47.8095 6.93L46.8743 11L50.3986 8.84053ZM68.8215 11L65.2972 8.84053L61.7729 11L62.7081 6.93L59.5944 4.19158L63.6947 3.83842L65.2972 0L66.8997 3.83842L71 4.19158L67.8863 6.93L68.8215 11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_2214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 11,
    fill: "#1A1A1A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.4fe67ad09790d59ff93b694da68db860.svg";
export { ForwardRef as ReactComponent };